// extracted by mini-css-extract-plugin
module.exports = {"adminPreview":"AdminPreview_adminPreview__1xVVP","compareStructureTable":"AdminPreview_compareStructureTable__1IsZy"};